import { ExperimentPageType } from '../ExperimentPageType'

import {
  EXPERIMENT_NAME_COMPETERA,
  EXPERIMENT_NAME_CONTACT_PAGE_REDESIGN,
  EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR,
  EXPERIMENT_NAME_HEADER_MOBILE_ICON_LIST,
} from './EXPERIMENT_NAME'
import { type TenantBasedExperiment } from './Experiment.types'

export const experimentsPerPage = {
  [ExperimentPageType.Account]: [EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR],
  [ExperimentPageType.Contact]: [EXPERIMENT_NAME_CONTACT_PAGE_REDESIGN],
  [ExperimentPageType.Default]: [
    EXPERIMENT_NAME_HEADER_MOBILE_ICON_LIST,
    EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR,
    EXPERIMENT_NAME_COMPETERA,
  ],
  [ExperimentPageType.Product]: [EXPERIMENT_NAME_DISCOUNT_REMOVAL_FR],
} satisfies Partial<
  Record<ExperimentPageType, (TenantBasedExperiment | string)[]>
>
